// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimEvaluationRow-cls1_Weh","cls2":"ClaimEvaluationRow-cls2_m_u ClaimEvaluationRow-cls1_Weh"};